export default __webpack_public_path__ + "static/media/kalte_schatten_cover.acc91225.webp";